import { HeadToHeadCardStyle } from '../cms-config';
import marketTile from './h2h-market-tile/h2h-market-tile.vue';
import summaryWithChart from './h2h-summary-with-chart/h2h-summary-with-chart.vue';

const components = {
  [HeadToHeadCardStyle.SplitBarClassic]: marketTile,
  [HeadToHeadCardStyle.SplitImage]: marketTile,
  [HeadToHeadCardStyle.SplitBarChunky]: marketTile,
  [HeadToHeadCardStyle.SummaryWithChart]: summaryWithChart,
};

export function resolveHeadToHeadComponent(style) {
  return components[Number(style)] || marketTile;
}
